import { createStore, useStore as baseUseStore, Store } from "vuex";
import createPersistedState from "vuex-persistedstate";
import { InjectionKey } from "vue";
import { userService } from "@/service";
import { State } from "./index.interface";

export const key: InjectionKey<Store<State>> = Symbol("base");
export const store = createStore<State>({
  plugins: [
    createPersistedState({
      reducer(state: State) {
        return {
          token: state.token
        };
      }
    })
  ],
  state: {
    token: undefined,
    userInfo: null,
    shopConfig: null
  },
  mutations: {
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo;
    },
    setToken(state, token: string) {
      state.token = token;
    },
    setShopConfig(state, config) {
      state.shopConfig = config;
    }
  },
  getters: {
    userInfo: state => state.userInfo,
    shopConfig: state => state.shopConfig
  },
  actions: {
    setPower({ commit }, list) {
      commit("setPower", list);
    },
    async getShopConfig({ commit }) {
      try {
        const { data } = await userService.getShopConfig();
        commit("setShopConfig", data);
      } catch (error) {
        commit("setShopConfig", null);
      }
    },
    async getUserInfo({ commit }) {
      try {
        const { data } = await userService.getUserInfo();
        commit("setUserInfo", data.data);
      } catch (error) {
        commit("setToken", "");
      }
    }
  },
  modules: {}
});

export function useStore() {
  return baseUseStore(key);
}
